var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ins-header'),_c('router-view'),_c('ins-footer'),(_vm.isMobile)?_c('ins-slide-menu',{attrs:{"direction":'right'}},[_c('ins-menu-layout')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }